import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';
import BookAppointmentButton from './BookAppointmentButton';

const NAV_ITEMS = [
  { path: '/', label: 'Home' },
  { path: '/services', label: 'Services' },
  { path: '/loans', label: 'Loans' },
  { path: '/about', label: 'About' },
  { path: '/contact', label: 'Contact' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-md shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 cursor-pointer" data-testid="header-logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_4085bf83-1b67-4600-9400-162cbac32cc2/artifacts/bitsnd1i_Screenshot%202026-03-24%20at%2011.14.19%E2%80%AFPM.png" 
              alt="AssetWise Business Consultants" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {NAV_ITEMS.map(({ path, label }) => (
              <Link 
                key={path}
                to={path}
                data-testid={`nav-link-${label.toLowerCase()}`}
                className={`font-medium transition-colors ${isActive(path) ? 'text-cyan-600' : 'text-gray-700 hover:text-cyan-600'}`}
              >
                {label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="tel:+912231628431" className="flex items-center text-cyan-600 font-semibold hover:text-cyan-700 transition-colors" data-testid="header-phone-link">
              <Phone className="w-4 h-4 mr-2" />
              +91 22316 28431
            </a>
            <BookAppointmentButton label="Book Appointment" testId="header-book-appointment-btn" />
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-cyan-600 hover:bg-gray-100 transition-colors"
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white" data-testid="mobile-menu">
          <div className="px-4 pt-2 pb-4 space-y-2">
            {NAV_ITEMS.map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                onClick={() => setIsMenuOpen(false)}
                data-testid={`mobile-nav-link-${label.toLowerCase()}`}
                className={`block w-full text-left px-3 py-2 rounded-md transition-colors ${isActive(path) ? 'bg-cyan-50 text-cyan-600' : 'text-gray-700 hover:bg-gray-50 hover:text-cyan-600'}`}
              >
                {label}
              </Link>
            ))}
            <div className="px-3 py-2">
              <BookAppointmentButton
                label="Book Appointment"
                className="w-full"
                testId="mobile-book-appointment-btn"
              />
            </div>
            <a href="tel:+912231628431" className="block px-3 py-2">
              <Button className="w-full bg-gradient-to-r from-cyan-500 to-teal-600 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
